module.exports = __webpack_public_path__ + "assets/img/medin_case.2d980dcd.png";